<template>
  <svg
    width="977"
    height="1005"
    viewBox="0 0 977 1005"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_f_8008_12757)">
      <ellipse
        cx="82.1595"
        cy="110.372"
        rx="82.1595"
        ry="110.372"
        transform="matrix(-0.866025 0.5 0.5 0.866025 504.305 366)"
        fill="#A370F7"
      />
    </g>
    <defs>
      <filter
        id="filter0_f_8008_12757"
        x="0.078949"
        y="0.389374"
        width="976.519"
        height="1004.55"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood
          flood-opacity="0"
          result="BackgroundImageFix"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="199.105"
          result="effect1_foregroundBlur_8008_12757"
        />
      </filter>
    </defs>
  </svg>
</template>
